import * as actionTypes from './action';
export const initState = {
	pageList: [], // 列表数组
	visible: false, // 是否展示 FunctionModal
	tableLoading: false, //
	personalInformation: {}, // 今日审核人员数据
	total: 0, // 列表中的总数,
	reviewedCount: 0, // 已审核总数
	insCount: 0, // 图片组总数
	modalTitle: '', // 模态框名称
	waterFallTitle: '', // 瀑布流名称
	modalRightCount: 0, // 瀑布流右侧数量
	insGroup: [], // 模态框中瀑布流的图片列表
	// tagInsGroup: [], // 打标签页面的tag数组
	colCount: 7, // 模态框中瀑布流的图片列数
	groupData: {}, // 当前图组的属性
	setCurrent: 0, // 当前所处位置
	handleTagVisible: false, // 是否展示标签编辑栏
	functionModalLoading: false, // 模态框是否处于加载状态
	tags: [], // 图片标签下列表头的数据
	tagList: [], // 标签下拉框的数据
	tagHeadTags: [], // 图片标签下列表头下拉框的数据
	tagHeadListLoading: false, // 图片标签下列表头下拉框的加载
	showActivityTags: [], // 用于展示标签
	passAllButtonLoading: false, // 全部通过按钮是否在加载
	page: 1, // 当前页面
	checkedAll: false, // 是否全选当页
	username: '', // 登录的用户
	addNewTagModalVisible: false, // 新增标签模态框
	tagsCache: [], // 选择标签的缓存
	tagsFetchLoading: false, // 加载 Select 下拉框的时候是否加载 
	virtualWaterUpdate: false, // 是否更新虚拟列表 
	watchUpModalVisible: false, // 查看页面
	watchUpModalSource: [], 
	bigImgModalVisible: false,
	bigImgModalSource: '',
	reflashList: false, // 是否刷新列表
	watchUpModel: 0, // 查看modal框的模式
};

export const reducer = (state, action) => {
	switch (action.type) {
		case actionTypes.setData:
			return {
				...state,
				...action.data,
			};
		case actionTypes.modalRightCountIncrease:
			return {
				...state,
				modalRightCount: ++state.modalRightCount,
			};
		case actionTypes.setTagInsGroup:
			const tagInsGroup = [];
			for (let v of state.insGroup) {
				if (tagInsGroup.length >= 14) {
					break;
				}
				if (!v.tags && !v.delete && !v.newTags) {
					tagInsGroup.push(v);
				}
			}
			return {
				...state,
				insGroup: [...tagInsGroup],
			};
		case actionTypes.getTagsCache:
			const tagsCache = JSON.parse(localStorage.getItem('tagsCache')) ?? [];
			const result = tagsCache.filter(t => Number.isInteger(Number(t.parentId)));
			return {
				...state,
				tagsCache: result,
			}
		case actionTypes.setTagsCache:
			const i = state.tagsCache.findIndex(v => (v.id === action.newTag.id) && (v.parentId === action.newTag.parentId));
			if (i === -1) {
				state.tagsCache.unshift(action.newTag);
			}
			// console.log('state.tagsCache', state.tagsCache);
			if (state?.tagsCache?.length > 10) {
				state.tagsCache = state.tagsCache.slice(0, 10);
			}
			localStorage.setItem('tagsCache', JSON.stringify(state.tagsCache));
			return {
				...state,
				tagsCache:[...state.tagsCache],
			};
		default:
			return state;
	}
};
